import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import useStyleUtils from "../../../../utilities/styles";
import { Checkbox, Text } from "@fluentui/react-components";
import IPersonalPasswordFieldProps from "./IPersonalPasswordFieldProps";

export default function PersonalPasswordField(props: IPersonalPasswordFieldProps) {
    const { t } = useTranslation();
    const style = useStyleUtils();
    
    return (
        <Row>
            <Col className={style.mb3}>
                <div className={style.mb1}>
                    <Checkbox
                        label={t("passwords.form.fields.personal.label")}
                        checked={props.isPersonal}
                        onClick={() => props.onChange(!props.isPersonal)}
                        />
                    <Text size={300} className={style.dBlock}>{t("passwords.form.fields.personal.description")}</Text>
                </div>
            </Col>
        </Row>
    );
}